import { ExclamationCircleOutlined } from "@ant-design/icons";

const NotFound = () => {
  return (
    <div className="notFoundPage">
      <div className="notFoundIcon" aria-hidden="true">
        <ExclamationCircleOutlined />
      </div>
      <h1 className="notFoundTitle">页面未找到</h1>
      <p className="notFoundDescription">
        您访问的页面不存在，请检查地址是否正确。
      </p>
    </div>
  );
};

export default NotFound;
